import React from 'react';

import ClaimStepContainer from '../common/ClaimStepContainer';

function CashOnDeliveryStepContainer(props) {
  return <ClaimStepContainer {...props} subHeading="CASH_ON_DELIVERY_CLAIM_FLOW_HEADING" confirmExit />;
}

export default React.memo(CashOnDeliveryStepContainer);
